import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
    alignSelf: 'stretch',
    boxSizing: 'border-box',
    marginTop: theme.spacing(3),
    padding: theme.spacing(3),
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.dividerV2.main}`,
    backgroundColor: theme.palette.bg.main,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    fontSize: theme.spacing(2.25),
    fontWeight: 500,
    lineHeight: theme.spacing(3),
    letterSpacing: '0.15px',
    color: theme.palette.labraText.primary,
  },
  statusError: {
    marginBottom: theme.spacing(2),
    fontSize: theme.spacing(1.75),
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.1px',
    color: theme.palette.error.main,
  },
}))
